<template>
  <div class="message-text__wrap bubble-phone">
    <div class="text-content">
      <span v-for="item in extractedMessages" :key="item.text">
        <a-popover
          v-if="item.isPopover"
          :title="$t('CHAT_LIST.PHONE_POPOVER.TITLE')"
        >
          <template #content>
            <div class="popover-confirm">
              <a-button type="primary" @click="updatePhone(item.phone)">
                {{ $t('CHAT_LIST.PHONE_POPOVER.BUTTON_ACTION') }}
              </a-button>
            </div>
          </template>
          <span class="popover-text text-phone" v-html="item.text" />
        </a-popover>
        <span v-else v-html="item.text" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    extractedMessages: {
      type: Array,
      default: () => [],
    },
    phoneNumbersFound: {
      type: Array,
      default: () => [],
    },
    sender: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  mounted() {
    let copy = this.message;
    let begin = 0;
    let self = this;
    let result = [];
    this.phoneNumbersFound.forEach(item => {
      // result.push({
      //   text: copy.substring(item.startsAt, item.endsAt - item.startsAt),
      //   phone: item.number.number
      // });
      if (item.startsAt - begin > 0) {
        self.extractedMessages.push({
          text: copy.substring(begin, item.startsAt - begin),
        });
      }
      self.extractedMessages.push({
        text: copy.substring(item.startsAt - begin, item.endsAt - begin),
        phone: item.number.number,
        isPopover: item.number.number != self.sender.phone_number,
      });
      copy = copy.substring(item.endsAt + begin);

      begin += self.message.length - copy.length;
    });
  },
  methods: {
    updatePhone(phone) {
      const contactUpdate = {
        phone_number: phone,
        id: this.sender.id,
      };
      this.$emit('update-phone', contactUpdate);
    },
  },
};
</script>
<style lang="scss" scoped>
.text-content {
  overflow: auto;

  ul,
  ol {
    padding-left: var(--space-two);
  }
  table {
    margin: 0;
    border: 0;

    td {
      margin: 0;
      border: 0;
    }

    tr {
      border-bottom: 0 !important;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--font-size-normal);
  }
}

// Style custom
.message-text__wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .text-content {
    margin-right: 5px;
  }
  .phoneNumber {
    font-weight: 500;
    text-decoration: underline;
  }
}

.popover-button-yes {
  padding: 0 7px;
}
.popover-confirm {
  text-align: end;
}
.bubble-phone {
  .text-phone {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
